/**
 * @module ProductCard
 */

import Component from '../base/Component';
import './styles.css';

import Rating from '../base/Rating';

// Везде, где есть карточка товара, необходим CSS-класс для определения touch-устройства
import '../../scripts/isTouchFlag';

/**
 * Карточка товара.
 */
export default class ProductCard extends Component {
    static className = 'product-card';

    initElements() {
        this.elements = {
            $rating: $('.rating', this.$block),
        };
    }

    init(options) {
        super.init(options);

        this.setRating();
    }

    setRating() {
        const rating = new Rating(this.elements.$rating);

        rating.init();
    }
}

if (window.location.pathname.indexOf('/html/') === 0) {
    // eslint-disable-next-line no-unused-expressions,import/extensions
    import('./env-frontend.js');
} else {
    // eslint-disable-next-line no-unused-expressions,import/extensions
    import('./env-backend.js');
}
